import React from "react";
import "./styles.css";

const VizIcon = ({ isActive, handleClick, withMargin }) => {
  return (
    <div className={`icon-container ${withMargin ? "icon-margin-btm" : ""}`} id="invite">
      <a className="icon-anchor" onClick={handleClick}>
        <svg
          className="svg-container element-icon"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          xmlnsserif="http://www.serif.com/"
        >
          <g transform="matrix(1.79021,0,0,1.79021,53.7063,19.6923)">
            <circle className={`el-circle ${isActive ? "active" : ""}`} cx="113" cy="132" r="143" />
          </g>

          <g className="el-path" transform="matrix(15.65,0,0,15.65,68.2,68.2)">
            <g>
              <path d="M4.293,4.293C4.48,4.105 4.735,4 5,4L7,4C7.552,4 8,3.552 8,3C8,2.448 7.552,2 7,2L5,2C4.204,2 3.441,2.316 2.879,2.879C2.316,3.441 2,4.204 2,5L2,7C2,7.552 2.448,8 3,8C3.552,8 4,7.552 4,7L4,5C4,4.735 4.105,4.48 4.293,4.293Z" />
              <path d="M17,2C16.448,2 16,2.448 16,3C16,3.552 16.448,4 17,4L19,4C19.265,4 19.52,4.105 19.707,4.293C19.895,4.48 20,4.735 20,5L20,7C20,7.552 20.448,8 21,8C21.552,8 22,7.552 22,7L22,5C22,4.204 21.684,3.441 21.121,2.879C20.559,2.316 19.796,2 19,2L17,2Z" />
              <path d="M21,16C21.552,16 22,16.448 22,17L22,19C22,19.796 21.684,20.559 21.121,21.121C20.559,21.684 19.796,22 19,22L17,22C16.448,22 16,21.552 16,21C16,20.448 16.448,20 17,20L19,20C19.265,20 19.52,19.895 19.707,19.707C19.895,19.52 20,19.265 20,19L20,17C20,16.448 20.448,16 21,16Z" />
              <path d="M4,17C4,16.448 3.552,16 3,16C2.448,16 2,16.448 2,17L2,19C2,19.796 2.316,20.559 2.879,21.121C3.441,21.684 4.204,22 5,22L7,22C7.552,22 8,21.552 8,21C8,20.448 7.552,20 7,20L5,20C4.735,20 4.48,19.895 4.293,19.707C4.105,19.52 4,19.265 4,19L4,17Z" />
              <path d="M10,12C10,10.895 10.895,10 12,10C13.105,10 14,10.895 14,12C14,13.105 13.105,14 12,14C10.895,14 10,13.105 10,12Z" />
              <path d="M12,6.004C10.311,6.004 8.661,6.507 7.259,7.449C5.858,8.391 4.768,9.729 4.13,11.292C4.124,11.308 4.118,11.324 4.112,11.34C3.963,11.767 3.963,12.233 4.112,12.66C4.118,12.676 4.124,12.692 4.13,12.708C4.768,14.271 5.858,15.609 7.259,16.551C8.661,17.493 10.311,17.996 12,17.996C13.689,17.996 15.339,17.493 16.741,16.551C18.142,15.609 19.232,14.271 19.87,12.708C19.876,12.692 19.882,12.676 19.888,12.66C20.037,12.233 20.037,11.767 19.888,11.34C19.882,11.324 19.876,11.308 19.87,11.292C19.232,9.729 18.142,8.391 16.741,7.449C15.339,6.507 13.689,6.004 12,6.004ZM8.375,9.109C9.447,8.389 10.709,8.004 12,8.004C13.291,8.004 14.554,8.389 15.625,9.109C16.683,9.819 17.508,10.825 17.998,12C17.508,13.175 16.683,14.181 15.625,14.891C14.554,15.612 13.291,15.996 12,15.996C10.709,15.996 9.447,15.612 8.375,14.891C7.317,14.181 6.492,13.175 6.002,12C6.492,10.825 7.317,9.819 8.375,9.109Z" />
            </g>
          </g>
        </svg>
        {!isActive && (
          <div className="tooltip">
            <p>Visualization controls</p>
            <div className="triangle"></div>
          </div>
        )}
        {isActive && <div className="triangle menu"></div>}
      </a>
    </div>
  );
};
export default VizIcon;
